import moment from "moment";
import React from "react";
import styled from "styled-components";
import {ButtonPrimary} from "ui/base/Button/ButtonStyled";
import {UserIcon} from "ui/icons";
import {defaultThemeColors, fonts} from "ui/theme";
import {Countdown} from "../countdown/Countdown";
import {ClassDateCard} from "../dateCard/ClassDateCard";
import {Avatar} from "../editAvatar/Avatar";
import {DEFAULT_TIMEZONE, timeLeftToAcceptOrDecline} from "utils";

require("moment-timezone");


export const RequestedClassCardInstructor = ({
                                                 requestedClass,
                                                 classType,
                                                 onAccept,
                                                 onDecline,
                                                 onProfile,
                                             }) => {
    const bookingSlot = requestedClass?.booking_slots?.[0];

    const dateTimeAfter25Hours = timeLeftToAcceptOrDecline(
        bookingSlot?.created_at,
        bookingSlot?.class_date,
        bookingSlot?.class_time,
        bookingSlot?.time_zone
    );

    const class_type = requestedClass?.class_type
        ? requestedClass?.class_type.toLowerCase()
        : "";

    const isOnline = requestedClass?.online_type === "online"

    const badgeVariant = isOnline ? "black_fade_small" : class_type === "private" ? "primary_fade_small" : "destructive_fade_small"

    const dates = requestedClass?.booking_slots?.map((item) => {
        const momentDateTime = moment.tz(
            `${item.class_date} ${item.class_time}`,
            "YYYY-MM-DD HH:mm:ss",
            item.time_zone || DEFAULT_TIMEZONE
        );

        return {
            id: item.id,
            type: requestedClass?.class_type,
            date: momentDateTime.format("MMM D, YYYY"),
            time: momentDateTime.format("h:mm a"),
            cost: item?.teacher_received_class_amount,
            teache_fee: item?.system_fee,
            discount_amount: item?.discount_amount,
            booking_total_amount: item?.booking_total_amount,
            tax: item?.tax
        };
    });

    return (
        <ClassItem>
            <ClassInfo>
                <Avatar
                    profile={requestedClass?.user?.profile_pic}
                    alt={requestedClass?.user?.first_name}
                    onClick={(() => onProfile?.())}
                />

                <InfoContainer>
                    <Info>
                        <NameContainer>
                            <Name onClick={(() => onProfile?.())}>{requestedClass?.user?.first_name}</Name>
                        </NameContainer>

                        <Details>
                            <span>
                                <UserIcon color="placeholder" width="15" height="15"/>
                            </span>
                            <span>{requestedClass?.student_per_class}</span> |{" "}
                            <span>{classType}</span>
                        </Details>

                        <Countdown
                            targetTime={dateTimeAfter25Hours}
                            timezone={bookingSlot?.time_zone || DEFAULT_TIMEZONE}
                        />
                    </Info>


                    <div>
                        <ButtonPrimary
                            variant={badgeVariant}
                            style={{
                                pointerEvents: "none",
                            }}
                        >
                            {isOnline ? "Online" : class_type}
                        </ButtonPrimary>
                    </div>
                </InfoContainer>
            </ClassInfo>

            <ExpandedDetails>
                <div>
                    {dates?.map((date) => {
                        return (
                            <ClassDateCard
                                key={date.id}
                                date={date}
                                isOnline={isOnline}
                                priceBreakdown={{
                                    booking_total_amount: date.booking_total_amount,
                                    discount_amount: date?.discount_amount,
                                    teache_fee: date?.teache_fee,
                                    total_amount: date?.cost,
                                }}
                            />
                        );
                    })}
                </div>
                {requestedClass.status === "pending" ||
                requestedClass.status === "rescheduled" ? (
                    <Actions>
                        <ButtonPrimary onClick={onAccept}>Accept</ButtonPrimary>
                        <ButtonPrimary onClick={onDecline} variant="outline">
                            Decline
                        </ButtonPrimary>
                    </Actions>
                ) : null}
            </ExpandedDetails>
        </ClassItem>
    );
};

const ClassItem = styled.div`
    border-width: 2px;
    border-style: solid;
    border-color: ${defaultThemeColors.lightBlue};
    background-color: ${defaultThemeColors.white};
    border-radius: 8px;
    overflow: hidden;
    padding: 1.5rem;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const ClassInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
`;

const InfoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex: 1;
`;

const Info = styled.div`
    flex: 1;
    display: grid;
    gap: 0.5rem;
`;

const NameContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-startz;
`;

const Name = styled.div`
    font-size: ${fonts.sizes.regular};
    font-weight: bold;
    cursor: pointer;
`;

const Details = styled.div`
    font-size: ${fonts.sizes.small};
    color: ${defaultThemeColors.placeholder};
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.3rem;

    & span:nth-of-type(2) {
        color: ${defaultThemeColors.txt};
    }
`;

const ExpandedDetails = styled.div`
    padding-top: 1rem;
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
`;

const Actions = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.6rem;

    > * {
        grid-column: span 1;
    }

    &:has(> *:nth-child(3)) > :first-child {
        grid-column: span 2;
    }

    > :only-child {
        grid-column: span 2;
    }
`;
